import { formats } from '../../../common/format';
export let chartOption = function(data, total, currencySymbol) {
    let that = this
    return {
        legend: {
            show: false
        },
        series: [
            {
                type: 'pie',
                radius: ['54%', '86%'],
                data: data,
                center: ['50%', '50%'],
                avoidLabelOverlap: false,
                silent: true,
                label: {
                    show: true,
                    position: 'center',
                    emphasis: {
                        show: false
                    },
                    align: 'center',
                    formatter: (param) => {
                        // md-calculator Do not do currency internationalization 
                        let currency = param.noNeedCurreny
                            ? '$' + total
                            : formats.currency({ value: total, currencySymbol });
                        if (param.dataIndex === 0) {
                            return `{a|${currency}}\n{b|${that.$t(
                                'common:caculator.month1'
                            )}}`;
                        } else {
                            return '';
                        }
                    },
                    rich: {
                        a: {
                            color: '#191919',
                            fontSize: 18,
                            fontFamily: 'font-medium'
                        },
                        b: {
                            fontSize: 14,
                            color: '#bebebe',
                            fontFamily: 'font-normal',
                            lineHeight: 17
                        }
                    }
                },
                animationType: 'expansion',
                animationTypeUpdate: 'expansion',
                animationDuration: 1000,
                animationDurationUpdate: 1000
            }
        ]
    };
};

export let getTitleMap = function() {
    return {
        pi: {
            name: this.$t('common:caculator.pi'),
            color:
                window.sitePrepareData().pieColor ||
                window.sitePrepareData().themeColor
        },
        taxes: {
            name: this.$t('common:caculator.propertyTax'),
            color: '#9fe060'
        },
        homeInsurance: {
            name: this.$t('common:caculator.homeInsurance'),
            color: '#2c82bf'
        },
        hoaFee: {
            name: this.$t('common:caculator.hOAFees'),
            color: '#ffbb00'
        },
        chimeMaintenanceFee: {
            name: this.$t('common:caculator.chimeMaintenanceFee'),
            color: '#ffbb00'
        }
    };
};
